import { Button } from '@/components/ui/button';
import {
	readPublicRetrievalStatus,
	UserDocument,
} from '@/entities/user-document';
import { ArrowDownToLine, History, LockKeyhole, UserPlus } from 'lucide-react';
import { DateTime } from 'luxon';
import { DocumentStateBadge } from '../document-state-badge/document-state-badge';
import { PublicRetrievalBadge } from '../public-retrieval-badge/public-retrieval-badge';
import styles from './styles.module.scss';

type MobileDocumentsListProps = {
	data: UserDocument[];
	onDownload: (document: UserDocument) => void;
	onHistory: (document: UserDocument) => void;
	onAddSigner: (document: UserDocument) => void;
	onRevokePublicRetrieval: (document: UserDocument) => void;
};

export const MobileDocumentsList = (props: MobileDocumentsListProps) => {
	return (
		<div className={styles['mobile-documents-list']}>
			{props.data.map((document, index) => (
				<div key={document.Serial} className={styles.document}>
					<div className={styles.info}>
						<div className={styles.path}>
							{document.Path ?? 'Anonymous.pdf'}
						</div>
						<div className={styles.badges}>
							<DocumentStateBadge state={document.State} />
							<PublicRetrievalBadge
								status={readPublicRetrievalStatus(document)}
							/>
						</div>
						<div className={styles.signed}>
							{document.SignedAt
								? `Firmado en ${DateTime.fromISO(
									document.SignedAt,
								)
									.setLocale('es')
									.toLocaleString(DateTime.DATETIME_MED)}`
								: 'Pendiente de firmar'}
						</div>
						{document.CreatedAt && (
							<div className={styles.created}>
								Subido el{' '}
								{DateTime.fromISO(document.CreatedAt)
									.setLocale('es')
									.toLocaleString(DateTime.DATETIME_MED)}
							</div>
						)}
					</div>
					<div className={styles.actions}>
						{document.State === 'Signed' && (
							<Button
								variant="ghost"
								aria-label="Agregar firmante"
								onClick={() => props.onAddSigner(document)}
							>
								<UserPlus />
							</Button>
						)}
						{readPublicRetrievalStatus(document) === 'active' && (
							<Button
								variant="ghost"
								aria-label="Retirar descarga pública"
								onClick={() =>
									props.onRevokePublicRetrieval(document)
								}
							>
								<LockKeyhole />
							</Button>
						)}
						<Button
							variant="ghost"
							onClick={() => props.onDownload(document)}
						>
							<ArrowDownToLine />
						</Button>
						<Button
							variant="ghost"
							onClick={() => props.onHistory(document)}
						>
							<History />
						</Button>
					</div>
				</div>
			))}
		</div>
	);
};
